module.exports = __webpack_public_path__ + "img/logo.3807eb08.png";